import { AxiosResponse, CancelToken } from 'axios';
import { awApiWithPkg } from './Base';

export type ActionItemsLiteUpdate = {
  aggIDTag: string;
  aggIDValue: string;
  actionTypeTag: string;
  actionTypeValue: string;
  comment?: string;
  fixedComment?: string;
  status?: string;
  snoozeDate?: string;
  endDate: string;
};

export interface ActionItemLiteUpdateRestRequest {
  actionItemsLite: ActionItemsLiteUpdate[];
  analysisDate: string;
  pkg: string;
  purpose: string;
}

export function postUpdateAlertItems(
  request: ActionItemLiteUpdateRestRequest,
  cancelToken?: CancelToken
): Promise<AxiosResponse<ActionItemsLiteUpdate[]>> {
  const path = '/workflow/action-items-lite-update';
  return awApiWithPkg.post<ActionItemsLiteUpdate[]>(path, request, { cancelToken, params: { pkg: request.pkg } });
}

export type ActionItemsLite = {
  endDate: null | string;
  aggIDValue: string;
  aggIDTag: string;
  actionTypeTag: 'RULE' | 'CAMPAIGN';
  actionTypeValue: string;
  user: string;
  comment: string | null;
  fixedComment: string | null;
  status: string;
  snoozeDate: string | null;
  lastUpdatedTimestamp: number | null;
  category: string | null;
  priority: string | null;
};

export type GetActionItemsLiteUsingPOSTResponse = { [actionTypeTag: string]: ActionItemsLite[] };

/*
 * this name has poor relevance to ActionItemLite
 * but it is what is used at back end
 */
export type PortfolioAlertIdentifier = {
  aggIDTag: string;
  aggIDValue: string;
  actionTypeTag: string;
  actionTypeValues: string[];
};

export interface GetActionItemsLiteUsingPOSTRequest {
  analysisDate: string;
  pkg: string;
  portfolioAlertIdentifierList: PortfolioAlertIdentifier[];
  purpose: string;
}

export function getActionItemsLiteUsingPOST(
  request: GetActionItemsLiteUsingPOSTRequest,
  cancelToken?: CancelToken
): Promise<AxiosResponse<GetActionItemsLiteUsingPOSTResponse>> {
  const path = '/workflow/action-items-lite';
  return awApiWithPkg.post<GetActionItemsLiteUsingPOSTResponse>(path, request, { cancelToken });
}
